/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import tgbLogoAltImage from 'src/assets/tgb-logo-alt.png'
import Avatar from 'src/components/Avatar'
import FlexBox from 'src/components/Common/FlexBox'
import { APP_NAME } from 'src/constants'
import { pxToVw } from 'src/functions/units'
import { useMediaScreenType } from 'src/hooks/useMediaScreenType'

type Props = {
  hidden?: boolean
  title: string
}

const ModalV2Header = ({ hidden = false, title }: Props) => {
  const { isMobile } = useMediaScreenType()

  if (hidden) return null

  return (
    <StyledDialogHeader>
      <StyledDialogTitle columnGap={21} alignItems="center">
        <Avatar image={tgbLogoAltImage} circular size={pxToVw(75, isMobile ? 720 : 1920)} />

        <FlexBox flexDirection="column" rowGap={3}>
          <small>{APP_NAME}</small>
          <h1>{title}:</h1>
        </FlexBox>
      </StyledDialogTitle>
    </StyledDialogHeader>
  )
}

export default ModalV2Header

const StyledDialogHeader = styled.div`
  width: calc(100% - (${pxToVw(40)} * 2));
  position: relative;
  padding-bottom: ${pxToVw(40)};
  margin-inline: auto;
  border-bottom: solid 1px ${({ theme }) => theme.colors.gray200};
  z-index: 1;

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      width: calc(100% - (${pxToVw(40, 720)} * 2));
      padding-bottom: ${pxToVw(40, 720)};
    `}
  `}
`

const StyledDialogTitle = styled(FlexBox)`
  small {
    font-size: ${pxToVw(20)};
    color: ${({ theme }) => theme.colors.gray300};
  }

  h1 {
    margin: 0;
    font-size: ${pxToVw(30)};
    color: ${({ theme }) => theme.colors.gray600};
    font-weight: 500;
  }

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      small {
        font-size: ${pxToVw(20, 720)};
      }

      h1 {
       font-size: ${pxToVw(30, 720)};
      }
    `}
  `}
`
